<div class="input-wrapper">
  <div class="input-field">
    <span>De</span>
    <input type="number" class="input-number q-input-no-border" [(ngModel)]="lowValue" (ngModelChange)="setProgressStyle()" (blur)="changeInput(true)">
    <i *ngIf="lowSet" class="fas fa-times q-c-danger" (click)="deleteValue(true)"></i>
  </div>
  <div class="input-field">
    <span>À</span>
    <input type="number" class="input-number q-input-no-border" [(ngModel)]="highValue" (ngModelChange)="setProgressStyle()" (blur)="changeInput()">
    <i *ngIf="highSet" class="fas fa-times q-c-danger" (click)="deleteValue()"></i>
  </div>
</div>

<div class="slider">
  <div class="progress" #progress></div>
</div>
<div class="range-input">
  <input type="range" class="range-min" [(min)]="minValue" [(max)]="maxValue" [(ngModel)]="lowValue" (ngModelChange)="changeRange(true)" (mouseup)="changeInput(true)">
  <input type="range" class="range-max" [(min)]="minValue" [(max)]="maxValue" [(ngModel)]="highValue" (ngModelChange)="changeRange()" (mouseup)="changeInput()">
</div>
